import { parseQuotationError } from 'components/ordering/quotation/api/dtos/error.js'


export abstract class QuotationRequest<T, E> {
  abstract path: string
  init?: RequestInit
  expectedErrors: readonly number[] = []

  parseResponse?: (json: unknown) => T

  parseError = (status: number, json: unknown) =>
    parseQuotationError(status, json, this.expectedErrors) as E
}
